<div class="modal-header">
    <h5 class="modal-title">SSO Login</h5>
    <button type="button" class="close" (click)="close('Cross click')" aria-label="Close">
        <span>&times;</span>
    </button>
</div>
<div class="modal-body" tabindex="0" ngbAutofocus>
    <button type="button" class="btn btn-outline-primary btn-block my-2" tabindex="5" (click)="close(SsoProvider.GOOGLE)" rippleEffect>
        <span class="brand-icon google_icon"></span> Sign In with Google
    </button>
    <button type="button" class="btn btn-outline-primary btn-block my-2" tabindex="5" (click)="close(SsoProvider.PINGONE)" rippleEffect>
        <span class="brand-icon pingone_icon"></span> Sign In with PingOne
    </button>
</div>